import React from 'react';
import { XMarkIcon } from '@heroicons/react/20/solid';

const AISuggestionsModal = ({ show, suggestions, onChange, onSave, onClose }) => {
  if (!show) return null;

  return (
    <div className="app-modal-overlay">
      <div className="relative w-full max-w-3xl rounded-2xl border border-slate-200 bg-white shadow-2xl animate-fade-in-up">
        <div className="app-modal-header">
          <h3 className="app-modal-title">AI Önerileri</h3>
          <button onClick={onClose} className="app-modal-close" aria-label="Kapat">
            <XMarkIcon className="h-5 w-5" />
          </button>
        </div>

        <div className="app-modal-body space-y-4">
          <div>
            <label htmlFor="ai-ozet" className="app-label">Özet</label>
            <textarea
              id="ai-ozet"
              name="ozet"
              value={suggestions.ozet}
              onChange={onChange}
              className="app-input min-h-[200px]"
              rows="8"
            />
          </div>
          <div>
            <label htmlFor="ai-baslik" className="app-label">Başlık</label>
            <input
              type="text"
              id="ai-baslik"
              name="baslik"
              value={suggestions.baslik}
              onChange={onChange}
              className="app-input"
            />
          </div>
          <div>
            <label htmlFor="ai-etiketler" className="app-label">Etiketler</label>
            <input
              type="text"
              id="ai-etiketler"
              name="etiketler"
              value={suggestions.etiketler.join(', ')}
              onChange={(e) => onChange({ target: { name: 'etiketler', value: e.target.value.split(', ') } })}
              className="app-input"
            />
          </div>
          <div>
            <label htmlFor="ai-kanunMaddeleri" className="app-label">Kanun Maddeleri</label>
            <input
              type="text"
              id="ai-kanunMaddeleri"
              name="kanunMaddeleri"
              value={suggestions.kanunMaddeleri.join(', ')}
              onChange={(e) => onChange({ target: { name: 'kanunMaddeleri', value: e.target.value.split(', ') } })}
              className="app-input"
            />
          </div>
        </div>

        <div className="flex justify-end gap-2 border-t border-slate-100 px-5 py-4">
          <button onClick={onClose} className="btn-secondary">
            İptal
          </button>
          <button onClick={onSave} className="btn-primary">
            Kaydet
          </button>
        </div>
      </div>
    </div>
  );
};

export default AISuggestionsModal;
